import { getI18n } from '@/utils/i18n';

const i18n = getI18n();

export const ERROR_CODES = {
  // 简历命中保护期
  700024: 700024,

  // 超过猎头投递次数限制
  701012: 701012,
  // 701026=查重进行中，请稍后查看推荐结果

  701026: 701026,
  // 701027=候选人重复，无法推荐

  701027: 701027,

  // JAVA ats-candidate
  400222: 400222, // 用户没有更新的权限
};

export const ERROR_CODE_TO_MESSAGE = {
  1: i18n.t`需要登录才能进行该操作`,
};
